export default __webpack_public_path__ + "close-thin.33b09b7aa537d8e5cc361a6fde097d8a.svg";